import { render } from "./Link.vue?vue&type=template&id=76946ff2"
import script from "./Link.vue?vue&type=script&lang=ts"
export * from "./Link.vue?vue&type=script&lang=ts"

import "./Link.vue?vue&type=style&index=0&id=76946ff2&lang=css"
script.render = render

export default script